export default {"src":"/_next/static/media/ball.fe53ff62.svg","height":48,"width":41,"blurWidth":0,"blurHeight":0};